module.exports = __webpack_public_path__ + "img/courier-loomis.9b9fba7f.svg";